"use client";

import React from "react";

type FloatingLabelProps = {
  htmlFor: string;
  value?: string | number | null;
  children: React.ReactNode;
  className?: string;
  isVisibleOverride?: boolean;
  inFlow?: boolean;
};

export const FloatingLabel: React.FC<FloatingLabelProps> = ({
  htmlFor,
  value,
  children,
  className = "",
  isVisibleOverride = false,
  inFlow = false,
}) => {
  const isVisible =
    isVisibleOverride ||
    (value !== null && value !== undefined && value !== "");
  return (
    <label
      htmlFor={htmlFor}
      className={
        inFlow
          ? `app-form-label ${className}`
          : `absolute -top-5 left-0 text-foreground text-sm rounded-2xl px-1 z-10
                  transition-opacity ${isVisible ? "" : "opacity-0"} ${className}`
      }
    >
      {children}
    </label>
  );
};
